import type { PayCashierSessionView } from "./CashierType";
import {
  CASHIER_PAY_VALID_MINUTES,
  coerceCashierDateTimeText,
  parseApiDateTime,
} from "./cashierDateTime";

const STORE_ORDER_SUBJECT_RE = /^店铺订单\s+/;

function normalizeTierSpecLabel(spec: string): string {
  const s = spec.trim();
  if (!s) {
    return "";
  }
  if (s.endsWith("个月")) {
    return `${s.slice(0, -2)}月`;
  }
  return s;
}

export function parseProductSummaryParts(summary: string | null | undefined): {
  name: string;
  spec: string;
} {
  const raw = summary?.trim() ?? "";
  if (!raw) {
    return { name: "", spec: "" };
  }
  const dot = raw.indexOf("·");
  if (dot >= 0) {
    return {
      name: raw.slice(0, dot).trim(),
      spec: normalizeTierSpecLabel(raw.slice(dot + 1)),
    };
  }
  return { name: raw, spec: "" };
}

export function resolveCashierProductName(session: PayCashierSessionView): string {
  const direct = session.productName?.trim() ?? "";
  if (direct && !STORE_ORDER_SUBJECT_RE.test(direct)) {
    return direct;
  }
  const fromSummary = parseProductSummaryParts(session.productSummary).name;
  if (fromSummary) {
    return fromSummary;
  }
  const subject = session.subject?.trim() ?? "";
  if (subject && !STORE_ORDER_SUBJECT_RE.test(subject)) {
    return subject;
  }
  return fromSummary || direct || subject || "—";
}

export function resolveCashierProductSpec(session: PayCashierSessionView): string {
  const direct = session.productSpec?.trim() ?? "";
  if (direct) {
    return normalizeTierSpecLabel(direct);
  }
  return parseProductSummaryParts(session.productSummary).spec;
}

/** 下单时间：优先接口字段，否则由 expireAt 反推（需后端按 30 分钟有效期返回） */
export function resolveCashierCreatedAt(session: PayCashierSessionView): string {
  const direct = coerceCashierDateTimeText(session.createdAt).trim();
  if (direct) {
    return direct;
  }
  const expire = parseApiDateTime(session.expireAt);
  if (!expire) {
    return "";
  }
  const createdMs =
    expire.getTime() - CASHIER_PAY_VALID_MINUTES * 60 * 1000;
  const d = new Date(createdMs);
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
}
